var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useMemo } from "react";
import SwitchTransferAmountInput from "./SwitchTransferAmountInput";
import InputField from "@frameworks/web/components/generic/inputField";
import SipCalendar from "@frameworks/shared-library/components/TransactionJourney/MutualFund/CommonComp/SipCalendar";
import LongTermUnitsCheckbox from "@frameworks/shared-library/components/TransactionJourney/MutualFund/SwitchTransferFund/LongTermUnitsCheckbox";
import { isEmpty, removeTrailingZeroes } from "@domains/utils/validation";
import { numberWithSuffix, roundUpToTwoDecimalPlaces, } from "@domains/utils/numberMethods";
import { acceptNumberOnly, } from "@frameworks/web/components/features/TOC/constant";
import { EInvestmentType, firstInstallmentConstentEnum, } from "@frameworks/shared-library/components/TransactionJourney/MutualFund/MutualFundConstant";
import moment from "moment";
import "@frameworks/shared-library/stylesheets/components/TransactionJourney/SwitchAndSTP/SwitchAndSTP.scss";
import { leadingZeroNumber, nonNumericChars, } from "@frameworks/salesjourney/utils/regex";
import GenericTooltip from "@frameworks/shared-library/components/GenericTooltip";
import GenericTooltipInnerContent from "@frameworks/shared-library/components/GenericTooltipInnerContent";
import { isNumber } from "underscore";
var SwitchTransferAmountFrom = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var isSTP = props.investmentType === EInvestmentType.STP;
    var stpData = useMemo(function () {
        var _a, _b, _c;
        return (_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.allmfData) === null || _a === void 0 ? void 0 : _a.returnTypeList) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.stpData;
    }, [props === null || props === void 0 ? void 0 : props.allmfData]);
    // *******************************************
    // *              USESTATES                  *
    // *******************************************
    //   NA
    // *******************************************
    // *           GENERATOR FUNCTIONS           *
    // *******************************************
    //   NA
    // *******************************************
    // *           HANDLER FUNCTIONS             *
    // *******************************************
    var handleOnChangeForAmountTransfer = function (value) {
        if (leadingZeroNumber.test(value)) {
            value = value.replace(/^0+/, "");
        }
        var inputNumericValue = value.replace(nonNumericChars, "");
        props.setAmountSelectedForTransfer(inputNumericValue);
        validateInputFieldsForStpTransfer(Number(inputNumericValue !== null && inputNumericValue !== void 0 ? inputNumericValue : ""));
    };
    var handleOnKeyDown = function (e) {
        if (e.key === "." || acceptNumberOnly(e.key)) {
            e.preventDefault();
        }
    };
    var handleOnChangeForInstallments = function (value) {
        var inputValue = Number(value);
        props.setNumberOfInstallmentsForTransfer(inputValue.toString());
        validateInputFieldsForStpTransfer(props.amountSelectedForTransfer, inputValue);
    };
    var handleOnChangeForStartDate = function (value) {
        props.setPurchaseFormData(__assign(__assign({}, props.purchaseFormData), { sipDate: String(value.value), startDay: String(value.label), startDt: moment(String(value.value)).format("YYYY-MM-DD") }));
    };
    // *******************************************
    // *           MISCELLANEOUS                 *
    // *******************************************
    var validateInputFieldsForStpTransfer = function (transferAmountInput, // value is string on inputfield change and Number when using long term units. Converting it to Number before using.
    installmentCountInput) {
        var _a, _b;
        if (isEmpty(stpData))
            return;
        var transferAmountValue = Number(transferAmountInput);
        var installmentNumber = installmentCountInput;
        var multiplier = getMultiplierAmount();
        var availableAmountToTransfer = +props.folio.freeQty * +props.folio.nav;
        var errors = {
            amount: { msg: "", status: false },
            installmentCount: { msg: "", status: false },
        };
        if (transferAmountValue > 0) {
            if (!isSTP && availableAmountToTransfer < minimumValidTransferAmount) {
                errors = __assign(__assign({}, errors), { amount: {
                        status: true,
                        msg: "Available balance in the selected folio is less than the min amount allowed for ".concat(props.investmentType === EInvestmentType.STP
                            ? "Systematic Transferring"
                            : "Switch fund", " of  ").concat(minimumValidTransferAmount),
                    } });
            }
            else if (isSTP && transferAmountValue % multiplier !== 0) {
                errors = __assign(__assign({}, errors), { amount: {
                        status: true,
                        msg: "Please ensure that the ".concat(props.investmentType, " amount is in multiples of ").concat(multiplier),
                    } });
            }
            else if (transferAmountValue < minimumValidTransferAmount) {
                errors = __assign(__assign({}, errors), { amount: {
                        status: true,
                        msg: "Please ensure that the entered ".concat(props.investmentType, " amount is in the range  of ").concat(minimumValidTransferAmount, " to ").concat(maximumValidTransferAmount, " for ").concat((_a = props === null || props === void 0 ? void 0 : props.allmfData) === null || _a === void 0 ? void 0 : _a.returnTypeList[0].schemeName),
                    } });
            }
            else if (transferAmountValue > maximumValidTransferAmount) {
                errors = __assign(__assign({}, errors), { amount: {
                        status: true,
                        msg: "Please ensure that the entered ".concat(props.investmentType, " amount is in the range  of ").concat(minimumValidTransferAmount, " to ").concat(maximumValidTransferAmount, " for  ").concat((_b = props === null || props === void 0 ? void 0 : props.allmfData) === null || _b === void 0 ? void 0 : _b.returnTypeList[0].schemeName),
                    } });
            }
            else {
                errors = __assign(__assign({}, errors), { amount: { status: false, msg: "" } });
            }
        }
        else {
            errors = __assign(__assign({}, errors), { amount: { status: false, msg: "" } });
        }
        if (installmentNumber >= 0) {
            if (installmentNumber < getMinimumInstallmentNumber()) {
                errors = __assign(__assign({}, errors), { installmentCount: {
                        status: true,
                        msg: "Please ensure that the continuity is greater than or equal to ".concat(getMinimumInstallmentNumber(), " months"),
                    } });
            }
            else if (installmentNumber > getMaximumInstallmentNumber()) {
                errors = __assign(__assign({}, errors), { installmentCount: {
                        status: true,
                        msg: "Please ensure that the continuity is less than or equal to ".concat(getMaximumInstallmentNumber(), " months"),
                    } });
            }
            else {
                errors = __assign(__assign({}, errors), { installmentCount: { status: false, msg: "" } });
            }
        }
        else {
            errors = __assign(__assign({}, errors), { installmentCount: { status: false, msg: "" } });
        }
        props.setFormErrors(errors);
    };
    useEffect(function () {
        if (props.folio && +props.amountSelectedForTransfer > 0)
            validateInputFieldsForStpTransfer(props.amountSelectedForTransfer);
    }, [props.folio, props.amountSelectedForTransfer]);
    var onLongTermUnitsChange = function (isChecked) {
        var _a, _b, _c;
        props.setIsLongTermOnly(isChecked);
        if (isChecked) {
            var values = [Number((_a = props.folio) === null || _a === void 0 ? void 0 : _a.longTermQty)];
            if (!isSTP) {
                values.push(Number((_b = props.folio) === null || _b === void 0 ? void 0 : _b.freeQty));
            }
            var calculateLongTermAmount = Math.min.apply(Math, __spreadArray([], __read(values), false)) * Number((_c = props.folio) === null || _c === void 0 ? void 0 : _c.nav);
            if (isSTP) {
                calculateLongTermAmount =
                    Math.floor(calculateLongTermAmount / getMultiplierAmount()) *
                        getMultiplierAmount();
            }
            var longTermAmount = Number(roundUpToTwoDecimalPlaces(calculateLongTermAmount));
            props.setAmountSelectedForTransfer(longTermAmount.toString());
            validateInputFieldsForStpTransfer(longTermAmount);
        }
        else {
            props.setAmountSelectedForTransfer("");
            validateInputFieldsForStpTransfer(0);
        }
    };
    var calculateAmountFromUnitsAndNav = function (units, nav) {
        if (units && nav) {
            var transferQuantity = Number(units);
            var newNav = Number(nav);
            if (transferQuantity && newNav) {
                var calculatedMinRedeemAmount = transferQuantity * newNav;
                return roundUpToTwoDecimalPlaces(calculatedMinRedeemAmount);
            }
        }
        return 0;
    };
    var getMinimumOutInstAmount = function () {
        if (!isEmpty(stpData)) {
            return stpData === null || stpData === void 0 ? void 0 : stpData[props === null || props === void 0 ? void 0 : props.stpFrequency].minOutInstAmt;
        }
    };
    var getMinRedeemQtyAmt = function () {
        var _a, _b;
        if (!isEmpty(stpData)) {
            return (+(stpData === null || stpData === void 0 ? void 0 : stpData[props === null || props === void 0 ? void 0 : props.stpFrequency].minRedQty) *
                +((_b = (_a = props === null || props === void 0 ? void 0 : props.allmfData) === null || _a === void 0 ? void 0 : _a.returnTypeList[0]) === null || _b === void 0 ? void 0 : _b.nav));
        }
    };
    // not confirmed on excel validations it is written this should happen on BE
    var getMinimumInInstAmount = function () {
        var _a;
        if (!isEmpty(props === null || props === void 0 ? void 0 : props.toSchemeValidationDetails)) {
            // return stpData?.[props?.stpFrequency]?.minInstAmt;
            return +((_a = props === null || props === void 0 ? void 0 : props.toSchemeValidationDetails) === null || _a === void 0 ? void 0 : _a.minInstAmt);
        }
    };
    var getMinimumOutInstallmentAmountFromUnits = function () {
        var _a, _b;
        var minUnits = stpData === null || stpData === void 0 ? void 0 : stpData[props === null || props === void 0 ? void 0 : props.stpFrequency].minInstUnit;
        var nav = (_b = (_a = props === null || props === void 0 ? void 0 : props.allmfData) === null || _a === void 0 ? void 0 : _a.returnTypeList[0]) === null || _b === void 0 ? void 0 : _b.nav;
        return calculateAmountFromUnitsAndNav(minUnits, nav);
    };
    var getMinimumInInstallmentAmountFromUnits = function () {
        var _a;
        return calculateAmountFromUnitsAndNav((_a = props === null || props === void 0 ? void 0 : props.toSchemeValidationDetails) === null || _a === void 0 ? void 0 : _a.minInstUnit, props.toSchemeValidationDetails.nav);
    };
    var minimumValidTransferAmount = useMemo(function () {
        var _a;
        if (isSTP) {
            return Math.max(Math.max(+getMinimumOutInstAmount(), +getMinimumInInstAmount()
            // +getMinimumOutInstallmentAmountFromUnits(),
            // +getMinimumInInstallmentAmountFromUnits()
            ));
        }
        else {
            return Math.max(+((_a = props === null || props === void 0 ? void 0 : props.toSchemeValidationDetails) === null || _a === void 0 ? void 0 : _a.minPurchaseAmt), +(stpData === null || stpData === void 0 ? void 0 : stpData[props === null || props === void 0 ? void 0 : props.stpFrequency].minRedAmt));
        }
    }, [stpData]);
    var getMaximumOutInstAmount = function () {
        var _a;
        if (!isEmpty(stpData)) {
            var maxOutInstAmt = Number((_a = stpData === null || stpData === void 0 ? void 0 : stpData[props === null || props === void 0 ? void 0 : props.stpFrequency]) === null || _a === void 0 ? void 0 : _a.maxOutInstAmt);
            return String(roundUpToTwoDecimalPlaces(maxOutInstAmt));
        }
    };
    // not confirmed on excel validations it is written this should happen on BE
    var getMaximumInInstAmount = function () {
        var _a;
        if (!isEmpty(props === null || props === void 0 ? void 0 : props.toSchemeValidationDetails)) {
            var maxInInstAmt = Number((_a = props === null || props === void 0 ? void 0 : props.toSchemeValidationDetails) === null || _a === void 0 ? void 0 : _a.maxInstAmt);
            return String(roundUpToTwoDecimalPlaces(maxInInstAmt));
        }
    };
    var getMaximumOutInstallmentAmountFromUnits = function () {
        var _a, _b;
        var maxUnits = stpData === null || stpData === void 0 ? void 0 : stpData[props === null || props === void 0 ? void 0 : props.stpFrequency].maxInstUnit;
        var nav = (_b = (_a = props === null || props === void 0 ? void 0 : props.allmfData) === null || _a === void 0 ? void 0 : _a.returnTypeList[0]) === null || _b === void 0 ? void 0 : _b.nav;
        return calculateAmountFromUnitsAndNav(maxUnits, nav);
    };
    var getMaximumInInstallmentAmountFromUnits = function () {
        var _a;
        return calculateAmountFromUnitsAndNav((_a = props === null || props === void 0 ? void 0 : props.toSchemeValidationDetails) === null || _a === void 0 ? void 0 : _a.maxInstUnit, props.toSchemeValidationDetails.nav);
    };
    var maximumValidTransferAmount = useMemo(function () {
        var _a, _b;
        if (isSTP) {
            return Math.min(+getMaximumOutInstAmount(), +getMaximumInInstAmount()
            // +getMaximumOutInstallmentAmountFromUnits(),
            // +getMaximumInInstallmentAmountFromUnits()
            );
        }
        else {
            return +((_a = props.folio) === null || _a === void 0 ? void 0 : _a.freeQty) * +((_b = props.folio) === null || _b === void 0 ? void 0 : _b.nav);
            // Math.min(
            // +getMaximumOutInstAmount(),
            // +getMaximumInInstAmount(),
            // !isSTP && +props.folio?.freeQty * +props.folio?.nav
            // +getMaximumOutInstallmentAmountFromUnits(),
            // +getMaximumInInstallmentAmountFromUnits()
            // );
        }
    }, [stpData, props.folio]);
    var getMinimumInstallmentNumber = function () {
        if (!isEmpty(stpData)) {
            return Number(stpData === null || stpData === void 0 ? void 0 : stpData[props === null || props === void 0 ? void 0 : props.stpFrequency].minInstNum);
        }
    };
    var getMaximumInstallmentNumber = function () {
        var _a;
        if (!isEmpty(stpData)) {
            var maxInstNum = Number((_a = stpData === null || stpData === void 0 ? void 0 : stpData[props === null || props === void 0 ? void 0 : props.stpFrequency]) === null || _a === void 0 ? void 0 : _a.maxInstNum);
            return maxInstNum;
        }
    };
    var getMultiplierAmount = function () {
        var _a;
        return Number((_a = stpData === null || stpData === void 0 ? void 0 : stpData[props === null || props === void 0 ? void 0 : props.stpFrequency]) === null || _a === void 0 ? void 0 : _a.outMulAmt);
    };
    var sipFreqForStp = useMemo(function () {
        var _a;
        var parseDate = function (dateStr) {
            return new Date(dateStr.split(" ").reverse().join(" "));
        };
        try {
            if (((_a = props.startDate) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                var dateList_1 = __spreadArray([], __read(props.startDate), false).sort(function (a, b) {
                    return parseDate(a).getTime() - parseDate(b).getTime();
                });
                var z_1 = 0;
                return __spreadArray([], __read(Array(28)), false).map(function (_, i) {
                    var value = "";
                    if (dateList_1[z_1] && i + 1 === parseDate(dateList_1[z_1]).getDate()) {
                        value = dateList_1[z_1];
                        z_1++;
                    }
                    return { label: i + 1, value: value };
                });
            }
        }
        catch (e) {
            console.log(e);
        }
    }, [props.startDate]);
    var getMaximumInstallmentLength = function () {
        var _a;
        var maxValue = Number(getMaximumInstallmentNumber());
        if (isNumber(maxValue) && !isNaN(maxValue)) {
            return (_a = maxValue === null || maxValue === void 0 ? void 0 : maxValue.toString()) === null || _a === void 0 ? void 0 : _a.length;
        }
    };
    var handleOnWheel = function (event) {
        event.currentTarget.blur();
    };
    // *******************************************
    // *            Rendering                    *
    // *******************************************
    return (React.createElement("section", { className: "details-container d-flex flex-column", id: "stp-switch-form-container" },
        React.createElement("div", { className: "" },
            React.createElement(SwitchTransferAmountInput, { amount: props.amountSelectedForTransfer, handleOnChangeInput: handleOnChangeForAmountTransfer, headerLabel: props.inputHeaderLabel, unitsLabel: "Units", name: "amountSelectedForTransfer", minAmount: removeTrailingZeroes(String(minimumValidTransferAmount)), isDisabled: props.isLongTermOnly, handleOnKeyDown: handleOnKeyDown, approxUnits: props.approxUnits, handleOnWheel: handleOnWheel }),
            React.createElement("div", null, ((_b = (_a = props.formErrors) === null || _a === void 0 ? void 0 : _a.amount) === null || _b === void 0 ? void 0 : _b.status) && (React.createElement("span", { className: "text-danger DMSansNormal_12_400 d-flex" },
                React.createElement("span", null,
                    React.createElement("i", { className: "edel-icon-validation pe-1 align-middle" })),
                React.createElement("span", null, props.formErrors.amount.msg))))),
        props.investmentType === EInvestmentType.STP && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "mgt-15" },
                React.createElement("div", { className: "d-flex" },
                    React.createElement("span", { className: "DMSans_13_400 txt_blackOne1 mgr-4" }, "Number of Installments")),
                React.createElement("div", null,
                    React.createElement(InputField, { autofocus: true, integer: true, name: "number of installments", inputMode: "numeric", placeholder: "Enter Instalment", type: "number", defaultValue: props.numberOfInstallmentsForTransfer, value: props.numberOfInstallmentsForTransfer, placeholderClassName: "amount", "box-disable": true, maxLength: getMaximumInstallmentLength(), className: "custom-box custom-box-relative installment-box", onChange: handleOnChangeForInstallments, onKeyDown: handleOnKeyDown, required: true, onWheel: handleOnWheel }),
                    React.createElement("span", { className: "DMSansNormal_12_400 text_box_bottom" },
                        "Min. ",
                        getMinimumInstallmentNumber()),
                    ((_c = props.formErrors) === null || _c === void 0 ? void 0 : _c.installmentCount.status) && (React.createElement("div", { className: "text-danger DMSansNormal_12_400 d-flex" },
                        React.createElement("span", null,
                            React.createElement("i", { className: "edel-icon-validation pe-1 align-middle" })),
                        React.createElement("span", null, props.formErrors.installmentCount.msg))))),
            React.createElement("div", { className: "mgt-20 transfer-calendar-section " },
                React.createElement("div", { className: "d-flex align-items-center gap-2" },
                    React.createElement(GenericTooltip, { placement: "bottom-start", toolTipText: React.createElement(GenericTooltipInnerContent, { tooltipTitle: "Transfer will be on ".concat(numberWithSuffix(Number(new Date((_d = props.purchaseFormData) === null || _d === void 0 ? void 0 : _d.sipDate).getDate())), " of every month") }), triggerType: "hover", toolTipClassName: "txn-mf-tooltip-info", noButton: true, button: React.createElement("span", { className: "DMSans_13_400 txt_blackOne1 mgr-10" },
                            "Monthly Transfer Date",
                            React.createElement("i", { className: "edel-icon-Information txt_secondary-gray plr-5 " })) })),
                React.createElement("span", null,
                    React.createElement(SipCalendar, { transactionType: props.investmentType, selectedVal: (_e = props.purchaseFormData) === null || _e === void 0 ? void 0 : _e.sipDate, setSelectedVal: handleOnChangeForStartDate, dateList: sipFreqForStp, setIsCalendarOpen: props.setIsCalendarOpen, isPayNow: ((_f = props.purchaseFormData) === null || _f === void 0 ? void 0 : _f.firstInstallment) ===
                            firstInstallmentConstentEnum.NOW, closeOnOutSideClick: true }))))),
        React.createElement("div", { className: "mt-20 mb-20 horizontal-divider" }),
        React.createElement(LongTermUnitsCheckbox, { onLongTermUnitsChange: onLongTermUnitsChange, isChecked: props.isLongTermOnly, headerLabel: "".concat(props.investmentType === EInvestmentType.STP ? "Transfer" : "Switch", " Long-Term Units Only"), footerLabel: "Helps you avoid exit loads and benefit from lower tax rates.", parentClassName: "m-bottom-64 " })));
};
export default SwitchTransferAmountFrom;
